<template>
<!--网站首页-->
  <el-container>
    <el-aside width="120px">
      <div class="userSHow" v-show="avatarUrl != ''" :title=username>
        <router-link to="/index/info">
          <el-avatar :size="80" :src=this.avatarUrl></el-avatar>
        </router-link>
        <!--        <span>{{username}}</span>-->
      </div>

      <div class="buttonGroup">
        <router-link to="/index/buy" active-class="active">
          <el-button type="warning" round>
            我要买车
          </el-button>
        </router-link>
        <router-link to="/index/sell" active-class="active">
          <el-button type="warning" round>
            我要卖车
          </el-button>
        </router-link>

        <router-link to="/index/order" active-class="active">
          <el-button type="warning" round>
            我的订单
          </el-button>
        </router-link>

        <router-link to="/index/mycar" active-class="active">
          <el-button type="warning" round>
            我的上架
          </el-button>
        </router-link>

      </div>

    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>

export default {
  name: "WebIndex",
  data(){
    return{
      avatarUrl: this.$store.state.UserInfo.user ? this.$store.state.UserInfo.user.user.avatar :'',
      title: this.$store.state.UserInfo.user ? '个人信息' : '请登录',
      username: this.$store.state.UserInfo.user ? this.$store.state.UserInfo.user.user.username :'请登录',
    }
  }
}
</script>

<style scoped>
.body{
  height: 200%;
  width: 100%;
  background-color: orange;
  text-align: center;
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  /*text-align: center;*/
  /*line-height: 160px;*/
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.userSHow {
  /*width: 30px;*/
  height: 110px;
  cursor: pointer;
}

.userSHow >>> span {
  /*display: inline;*/
  /*float: left;*/
  /*padding-left: 1%;*/
  /*padding-top: 1%;*/
  font-size: small;
  font-family: 幼圆;
  height: 30px;
  margin-top: 20px;
}

.buttonGroup {

}

.buttonGroup >>> button {
  display: inline-block;
  background-color: rgba(216,210,194,0.51);
  color: orangered;
  margin-top: 10%;
}

.active >>> button{
  /*text-decoration: none;*/
  color: white;
  background-color: rgba(255,83,15,0.6);
}
a{
  display: block;
  text-decoration: none;
  color: white;
  height: 100px;
  text-align: center;
  line-height: 120px;
}
</style>